import React, { useEffect, useState } from 'react';
import axios from 'axios'; // Adjust import path if necessary
import { Spinner, Table, Modal, Card, Row, Col, Button } from 'react-bootstrap';
import { var_api } from '../../constant';
import Nav from 'react-bootstrap/Nav';
import {Navbar,NavDropdown} from 'react-bootstrap';
import sage from "../../../images/splash/sage.jpeg";

const getFormattedDate = (daysBeforeToday) => {
    const date = new Date();
    date.setDate(date.getDate() - daysBeforeToday);
    return date.toISOString().split('T')[0];
  };
  
const Dashboard = () => {
    const [startDate, setStartDate] = useState(getFormattedDate(30));
  const [endDate, setEndDate] = useState(getFormattedDate(0));
  const [clientsData, setClientsData] = useState(null);
  const [saleSummary, setSaleSummary] = useState([]);
  const [membershipList, setMembershipList] = useState([]);
  const [couponList, setCouponList] = useState([]);
  const [transactionData, setTransactionData] = useState([]);
  const [popupOnlineServices, setPopupOnlineServices] = useState(false);
  const [onlineServiceData, setOnlineServiceData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [settings, setSettings] = useState(null);

  useEffect(() => {
  
    fetchClients();
    fetchSaleSummary();
    fetchMembershipList();
    fetchCouponList();
    fetchTransactionList();
    fetchShopSettings();
  }, [startDate, endDate]);

  const formatToDDMMYY = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear()).slice(-2);
    return `${day}-${month}-${year}`;
  };

  const fetchClients = async () => {
    try {
      const formattedStartDate = formatToDDMMYY(startDate);
      const formattedEndDate = formatToDDMMYY(endDate);
      const token = localStorage.getItem('token');
      const response = await axios.get(`${var_api}/api/booking/get-appointment-summary/${formattedStartDate}/${formattedEndDate}`, {
        headers: {
          Authorization: `${token}`
        }
      });
      setClientsData(response.data);
    } catch (error) {
      handleFetchError(error);
    }
  };

  const fetchSaleSummary = async () => {
    try {
      setLoading(true);
      const formattedStartDate = formatToDDMMYY(startDate);
      const formattedEndDate = formatToDDMMYY(endDate);
      const token = localStorage.getItem('token');
      const response = await axios.get(`${var_api}/api/booking/sales-summary/${formattedStartDate}/${formattedEndDate}`, {
        headers: {
          Authorization: `${token}`
        }
      });
      const topThreeServices = response.data
        .filter(service => service.service_name)
        .sort((a, b) => b.sales_qty - a.sales_qty)
        .slice(0, 3);
      setSaleSummary(topThreeServices);
    } catch (error) {
      handleFetchError(error);
    } finally {
      setLoading(false);
    }
  };

  const fetchMembershipList = async () => {
    try {
      setLoading(true);
      const formattedStartDate = formatToDDMMYY(startDate);
      const formattedEndDate = formatToDDMMYY(endDate);
      const token = localStorage.getItem('token');
      const response = await axios.get(`${var_api}/api/booking/membership-list-reports/${formattedStartDate}/${formattedEndDate}`, {
        headers: {
          Authorization: `${token}`
        }
      });
      setMembershipList(response.data.slice(-5));
    } catch (error) {
      handleFetchError(error);
    } finally {
      setLoading(false);
    }
  };

  const fetchCouponList = async () => {
    try {
      setLoading(true);
      const formattedStartDate = formatToDDMMYY(startDate);
      const formattedEndDate = formatToDDMMYY(endDate);
      const token = localStorage.getItem('token');
      const response = await axios.get(`${var_api}/api/booking/coupon-list-reports/${formattedStartDate}/${formattedEndDate}`, {
        headers: {
          Authorization: `${token}`
        }
      });
      setCouponList(response.data.slice(-5));
    } catch (error) {
      handleFetchError(error);
    } finally {
      setLoading(false);
    }
  };

  const fetchTransactionList = async () => {
    try {
      setLoading(true);
      const formattedStartDate = formatToDDMMYY(startDate);
      const formattedEndDate = formatToDDMMYY(endDate);
      const token = localStorage.getItem('token');
      const response = await axios.get(`${var_api}/api/booking/transaction-appointments-reports/${formattedStartDate}/${formattedEndDate}`, {
        headers: {
          Authorization: `${token}`
        }
      });
      setTransactionData(response.data.slice(-5));
    } catch (error) {
      handleFetchError(error);
    } finally {
      setLoading(false);
    }
  };

  const fetchShopSettings = async () => {
    const token = localStorage.getItem("token");
    try {
      setLoading(true);
      const response = await axios.get(`${var_api}/api/shop-settings/get`, {
        headers: {
          Authorization: `${token}`
        }
      });
      setSettings(response.data);
      // Optionally set other settings in local storage
    } catch (error) {
      handleFetchError(error);
    } finally {
      setLoading(false);
    }
  };

  const handleFetchError = (error) => {
    console.error("Error fetching data:", error);
    if (error.response && error.response.status === 401) {
    //   window.location.href = redirect;
    }
  };

  const openPopup = (data) => {
    setOnlineServiceData(data);
    setPopupOnlineServices(true);
  };

  return (
    <>
      {loading && (
        <div className="loading-spinner">
          <div className="spinner"></div>
        </div>
      )}
       <Navbar bg="light" expand="md" className="bg-body-tertiary" collapseOnSelect fixed="top">
  <Navbar.Brand href="#home">
    <img src={sage} alt="logo" className="img-fluid" style={{ maxWidth: "200px", margin: "3px 80px" }} />
  </Navbar.Brand>
  <Navbar.Toggle aria-controls="responsive-navbar-nav" />
  <Navbar.Collapse id="responsive-navbar-nav">
  <Nav className="mx-auto">
      <Nav.Link href="#" style={{ color: "black", fontSize:"25px", letterSpacing:"2px" }}>
       DASHBOARD 
      </Nav.Link>
    </Nav>
    <Nav className="ms-auto">
      <Nav.Link href="/sb-home" style={{ color: "black", fontSize: "15px" }}>
        <button className="btn" style={{backgroundColor:"rgb(89, 128, 71)", color:"white"}}>
          <i className="bi bi-house"></i> Go to home
        </button>
      </Nav.Link>
    </Nav>
  </Navbar.Collapse>
</Navbar>
<br/>
<br/>

<Row className="g-2 mt-3" style={{padding:"30px"}}>
  {clientsData &&
    Object.entries(clientsData).map(([key, value]) => (
      <Col key={key}
      xs={12} // Full width on extra small devices
      sm={6} // Half width on small devices
      md={3} // One-third width on medium devices
      lg={2} // One-fourth width on large devices
      className="mb-3">
        <Card
          className="text-center shadow-sm border-primary"
          style={{
            height: "5rem",
            width: "13rem", // Adjust the width as needed
            padding: "3px", // Compact padding
            borderWidth: "1px", // Thinner border
          }}
        >
          <Card.Body>
            <h6 style={{ fontSize: "0.8rem" }}>{key.replace(/_/g, ' ').toUpperCase()}</h6>
            <p className="h6">
              <span
                // className="text-primary border border-primary rounded px-2 py-1 d-inline-block"
                // style={{ borderWidth: "1px" }} // Thinner border for the text
              >
              {typeof value === "number" ? value.toFixed(2) : value || "-"}
              </span>
            </p>
          </Card.Body>
        </Card>
      </Col>
    ))}
</Row>
     {/* First Row */}

     
<Row className="mt-4" style={{padding:"10px"}}>
  <Col md="6">
    <Card style={{ height: '450px', overflow: 'auto', padding: '10px', width: '100%' }}>
      <Card.Body>
        <h5 className="card-title">Online Transaction Appointments</h5>
        <div className="live-preview">
          <div className="table-responsive text-center" style={{ maxWidth: '100%', overflowX: 'auto' }}>
            <Table striped bordered hover className="mb-0" style={{ minWidth: '800px' }}>
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Customer Name</th>
                  <th>Customer Mobile</th>
                  <th>Employee Name</th>
                  <th>Booking Date</th>
                  <th>Booking Time</th>
                  <th>Paid Amount</th>
                  <th>Total Amount</th>
                  <th>Slot Time</th>
                  <th>Transaction ID</th>
                  <th>Role</th>
                </tr>
              </thead>
              <tbody>
                {transactionData.length > 0 ? (
                  transactionData.map((client, index) => (
                    <tr key={client.email}>
                      <td>{index + 1}</td>
                      <td>{client.customer_name}</td>
                      <td>{client.customer_mobile}</td>
                      <td>{client.emp_name}</td>
                      <td>{client.booking_date}</td>
                      <td>{client.booking_time}</td>
                      <td>{client.paid_amount}</td>
                      <td>{typeof client.total_amount === "number" ? client.total_amount.toFixed(2) : client.total_amount || "-"}</td>
                      <td>{client.slot_time}</td>
                      <td>{client.transaction_id}</td>
                      <td>{client.role}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="11" className="text-center">No Data Available</td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </div>
      </Card.Body>
    </Card>
  </Col>

  <Col md="6">
    <Card style={{ height: '450px', overflow: 'auto', padding: '10px', width: '100%' }}>
      <Card.Body>
        <h5 className="card-title">Coupon Appointments</h5>
        <div className="live-preview">
          <div className="table-responsive text-center" style={{ maxWidth: '100%', overflowX: 'auto' }}>
            <Table striped bordered hover className="mb-0" style={{ minWidth: '800px' }}>
              <thead>
                <tr>
                  <th>S No</th>
                  <th>Booking Type</th>
                  <th>Customer Name</th>
                  <th>Customer Mobile</th>
                  <th>Booking Date</th>
                  <th>Booking Time</th>
                  <th>Slot Time</th>
                  <th>Total Amount</th>
                  <th>Transaction Id</th>
                  <th>Payment Status</th>
                  <th>Status</th>
                  <th>Emp Name</th>
                  <th>Role</th>
                  <th>Is Discount</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {couponList.length > 0 ? (
                  couponList.map((client, index) => (
                    <tr key={client.email}>
                      <td>{index + 1}</td>
                      <td>{client.booking_type === 1 ? 'Instant Booking' : client.booking_type === 2 ? 'Advanced Booking' : 'Unknown'}</td>
                      <td>{client.customer_name}</td>
                      <td>{client.customer_mobile}</td>
                      <td>{client.booking_date}</td>
                      <td>{client.booking_time}</td>
                      <td>{client.slot_time}</td>
                      <td>{typeof client.total_amount === "number" ? client.total_amount.toFixed(2) : client.total_amount || "-"}</td>
                      <td>{client.transaction_id}</td>
                      <td>{client.payment_status}</td>
                      <td>{client.status}</td>
                      <td>{client.emp_name}</td>
                      <td>{client.role}</td>
                      <td>{client.is_discount === 1 ? client.discount : client.price}</td>
                      <td>{client.date}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="15" className="text-center">No Data Available</td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </div>
      </Card.Body>
    </Card>
  </Col>
</Row>

     {/* Third Row */}
<Row className="mt-4" style={{padding:"30px"}}>
  <Col md="6">
    <Card style={{ height: '350px', overflow: 'hidden', padding: '10px', maxWidth: '100%' }}>
      <Card.Body>
        <h5 className="card-title">Membership Summary</h5>
        <div className="live-preview">
          <div className="table-responsive text-center scrollable-table" style={{ maxWidth: '100%' }}>
            <Table striped bordered hover className="mb-0" style={{ width: '100%' }}>
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Customer Name</th>
                  <th>Mobile</th>
                  <th>Employee Name</th>
                  <th>Token No</th>
                  <th>Total Service</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                {membershipList.length > 0 ? (
                  membershipList.map((member, index) => (
                    <tr key={member.email}>
                      <td>{index + 1}</td>
                      <td>{member.customer_name}</td>
                      <td>{member.customer_mobile}</td>
                      <td>{member.emp_name}</td>
                      <td>{member.token_no}</td>
                      <td>{member.services.length}</td>
                      <td>{member.total_amount}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="text-center">No Data Available</td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </div>
      </Card.Body>
    </Card>
  </Col>
  <Col md="6">
    <Card style={{ height: '350px', overflow: 'hidden', padding: '10px', maxWidth: '100%' }}>
      <Card.Body>
        <h5 className="card-title">Sales Summary</h5>
        <div className="live-preview">
          <div className="table-responsive text-center scrollable-table" style={{ maxWidth: '100%' }}>
            <Table striped bordered hover className="mb-0" style={{ width: '100%' }}>
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Service Name</th>
                  <th>Description</th>
                  <th>Sales Quantity</th>
                  <th>Service Sold</th>
                </tr>
              </thead>
              <tbody>
                {saleSummary.length > 0 ? (
                  saleSummary.map((sale, index) => (
                    <tr key={sale.month}>
                      <td>{index + 1}</td>
                      <td>{sale.service_name}</td>
                      <td>{sale.description}</td>
                      <td>{sale.sales_qty}</td>
                      <td>{sale.service_sold}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center">No Data Available</td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </div>
      </Card.Body>
    </Card>
  </Col>
</Row>

    </>
  );
};

export default Dashboard;